import { adminApiClient } from '../lib/apiClient';

export async function adminLogin(payload) {
  const formData = new FormData();

  formData.append('email', payload.email.trim());
  formData.append('password', payload.password);

  const response = await adminApiClient.post('/admin/login', formData);
  const result = response.data;

  if (result?.data?.token) {
    localStorage.setItem('admin_token', result.data.token);
    localStorage.setItem('admin_profile', JSON.stringify(result.data));
  }

  return result;
}

export function clearAdminSession() {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_profile');
}

export function getAdminToken() {
  return localStorage.getItem('admin_token');
}
